export const CAuthenticationRouteNames = {
  login: 'app.auth.login',
  register: 'app.auth.register',
  signIn: 'app.auth.signIn',
  logout: 'app.auth.logout',
  signInWithMagicUri: 'app.auth.signInWithMagicUri',
  oAuthCallback: 'app.auth.callback',
}
